import { useQuery } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { GeneticEvaluationController } from 'src/controllers/genetic-evaluation.controller'

const geneticEvaluationController = new GeneticEvaluationController()

export function useGetGeneticEvaluationList() {
  const { userFarm: farmId } = useAuth()

  return useQuery({
    queryKey: ['getGeneticEvaluationList', farmId],
    queryFn: () => geneticEvaluationController.getGeneticEvaluationListByFarmId(farmId!),
    enabled: !!farmId
  })
}
